
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 485.213 485.213"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M471.882 407.567L360.567 296.243a214.267 214.267 0 01-64.331 64.321L407.56 471.888c17.772 17.768 46.587 17.768 64.321 0 17.773-17.739 17.773-46.554.001-64.321zM363.909 181.955C363.909 81.473 282.44 0 181.956 0 81.474 0 .001 81.473.001 181.955s81.473 181.951 181.955 181.951c100.484 0 181.953-81.469 181.953-181.951zM181.956 318.416c-75.252 0-136.465-61.208-136.465-136.46 0-75.252 61.213-136.465 136.465-136.465 75.25 0 136.468 61.213 136.468 136.465 0 75.252-61.218 136.46-136.468 136.46z"}}),_c('path',{attrs:{"d":"M75.817 181.955h30.322c0-41.803 34.014-75.814 75.816-75.814V75.816c-58.517 0-106.138 47.621-106.138 106.139z"}})])
          )
        }
      }
    